import { Icon } from "@iconify/react/dist/iconify.js";
import { Link } from "react-router-dom";
import { AdminMenus } from "./admin";
import { UserMenus } from "./user";
import { MENU_ROUTE_PERMISSIONS } from "../../../../constants/menuPermissions";
import { normalizeLoginType } from "../../../../utils/auth";
import {
  getMenuPermissions,
  hasAnyPermission,
  hasFullAccess,
  shouldSyncPermissionsOnLoad,
} from "../../../../utils/permissions";
import { sidebarMenuIconClass } from "../style";

const renderMenuIcon = (iconName, size = 20) => (
  <span className={sidebarMenuIconClass}>
    <Icon icon={iconName} width={size} style={{ color: "currentColor" }} />
  </span>
);

export const canAccessMenuItem = (key, userData, permissionsOverride = null) => {
  const required = MENU_ROUTE_PERMISSIONS[key];
  if (!required || !required.length) return true;

  // Tenant users: always filter by the latest synced API permissions (no cache bypass).
  if (
    shouldSyncPermissionsOnLoad(userData) &&
    permissionsOverride !== null &&
    Array.isArray(permissionsOverride)
  ) {
    return hasAnyPermission(
      getMenuPermissions(userData, permissionsOverride),
      required
    );
  }

  if (hasFullAccess(userData)) return true;

  if (Array.isArray(permissionsOverride)) {
    return hasAnyPermission(
      getMenuPermissions(userData, permissionsOverride),
      required
    );
  }

  return hasAnyPermission(getMenuPermissions(userData), required);
};

const filterMenus = (menus, userData, permissionsOverride = null) =>
  menus
    .map((menu) => {
      if (menu.children?.length) {
        const children = menu.children.filter((child) =>
          canAccessMenuItem(child.key, userData, permissionsOverride)
        );
        if (!children.length) return null;
        return { ...menu, children };
      }
      return canAccessMenuItem(menu.key, userData, permissionsOverride)
        ? menu
        : null;
    })
    .filter(Boolean);

export const FindMenus = (type, userData = null, permissionsOverride = null) => {
  const menuType = normalizeLoginType(type);
  const sourceMenus = {
    admin: AdminMenus,
    user: UserMenus,
  }?.[menuType];

  const menus =
    menuType === "user" && userData
      ? filterMenus(sourceMenus || [], userData, permissionsOverride)
      : sourceMenus || [];

  return menus.map((d) => {
    if (d?.children) {
      return {
        ...d,
        icon: renderMenuIcon(d.icon, 20),
        label: typeof d.label === "function" ? d.label() : d.label,
        children: d?.children?.map((child) => ({
          ...child,
          icon: child.icon
            ? renderMenuIcon(child.icon, 18)
            : null,
          label: (
            <Link to={child.key}>
              {typeof child.label === "function" ? child.label() : child.label}
            </Link>
          ),
        })),
      };
    }
    return {
      ...d,
      icon: renderMenuIcon(d.icon, 20),
      label: (
        <Link to={d.key}>
          {typeof d.label === "function" ? d.label() : d.label}
        </Link>
      ),
    };
  });
};
